import { useQuery } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { EmailVerified } from 'v2/models';
import { unit } from 'mathjs';
import { fetchUserObject } from 'actions';
import { useDispatch } from 'react-redux';
import { useFreeUser } from './useFreeUser';

const EMAIL_VERIFICATION_STATUS_INTERVAL = unit('5s').toNumber('ms');

const useEmailVerification = (emailVerified: boolean) => {
  const dispatch = useDispatch();
  const [isFreeUser] = useFreeUser();
  const query = useQuery(
    ['email_verification_status'],
    async () => {
      return await restFactory.get<EmailVerified>(
        `/dj/api/v1/strapi_user/email_verification_status/`
      );
    },
    {
      enabled: isFreeUser && !emailVerified,
      refetchInterval: EMAIL_VERIFICATION_STATUS_INTERVAL,
      onSuccess: (data: EmailVerified) => {
        if (data.email_verified) {
          dispatch(fetchUserObject());
        }
      },
    }
  );

  return query;
};

export default useEmailVerification;
